import { Component, AfterViewInit, style, ViewChild, ElementRef, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import * as encoding from 'encoding-japanese';

import { ArrivePlanService } from '../../../service/arrive-plan/arrive-plan.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { isNumber } from '../../../util/util';
import { insertcomma, toInteger } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { GridButtonRenderComponent } from '../../../render/grid-button-render.component';
import { HeaderComponent } from 'app/menu/header/header.component';

@Component({
  selector: 'wa1014',
  templateUrl: 'wa1014.component.html',
  styleUrls: ['wa1014.component.scss']
})
export class Wa1014Component implements AfterViewInit, OnChanges {
  private gridApi: any;
  public componentTitle = 'WA1014:入荷実績登録';

  @ViewChild(HeaderComponent)
  private headerComponent: HeaderComponent;

  public locaObj: any = {};
  public ownerId: number;
  public gridOptions: GridOptions;
  public rowData: any[];

  public working = false;
  public height = 500;
  public gridHeight = 450;
  public production = environment.production;
  public backgroundColor: string;

  public gridEditFl = [];
  private errorMssageForLogin = '';

  private loginGridHelper: AgGridHelper;

  @ViewChild('loginGridView')
  loginGridView: ElementRef;

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private paginationGetRowCount = 0;
  private isSubmitButtonEnabled = false;

  @Input() isFromUnArrival = false;

  private isShowForceWin = false;
  private forceData = null;
  private errorMssage2 = '';
  private ARRIVE_RANDOM_PROP_NAME = '__index';
  private arrivePlan = null

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private arrivePlanService: ArrivePlanService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    const rows = localStorage.getItem('wa1014_rowsPerPage_idx');
    this.loginGridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      getContextMenuItems: this.getContextMenuItems,
      singleClickEdit: true,
      pagination: true,

      enableRangeSelection: true,
      localeText: environment.gridLocale,
      onColumnResized: params => {
        this.saveColumnWidth(params);
      },
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa1010_LOGIN_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }

        this.loginGridHelper.onGridReady();
      },
      onRowDataChanged: () => {
        this.loginGridHelper.onRowDataChanged();

        if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.loginGridHelper.isShowGridNoDataOverlay = false;
        else this.loginGridHelper.isShowGridNoDataOverlay = true;
      },
      overlayLoadingTemplate: this.loginGridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.loginGridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.loginGridHelper.fixedAgMenu();
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
      },
      onRowValueChanged: () => {
        this.ngDoCheck();
      }
    };
    this.loginGridHelper.setGridOptions(this.gridOptions);
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        field: 'unarr',
        suppressMenu: true,
        width: 135,
        cellClass: ['tc', 'cellclass'],
        cellRendererFramework: GridButtonRenderComponent,
        cellRendererParams: {
          buttonText: '強制入荷完了',
          onClick: this.showForceOverylay.bind(this)
        }
      },
      {
        headerName: '入荷予定ID',
        field: 'arriveplanId',
        sort: 'desc',
        width: this.getColumnWidth('arriveplanId', 100),
        cellClass: ['tr', 'cellclass'],
        suppressMenu: true,
        unSortIcon: true,
        suppressNavigable: true
      },
      {
        headerName: '入荷予定日',
        field: 'arriveplanDt',
        width: this.getColumnWidth('arriveplanDt', 100),
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 200),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        width: this.getColumnWidth('itemCd', 150),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '単位名',
        field: 'unitTx',
        width: this.getColumnWidth('itemunitTx', 100),
        cellClass: ['tc', 'cellclass']
      },
      {
        headerName: '入荷予定数',
        field: 'arriveplanNr',
        width: this.getColumnWidth('arriveplanNr', 100),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '入荷予定残数',
        field: 'arriveleftNr',
        width: this.getColumnWidth('arriveleftNr', 80),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '格納ロケーションコード',
        field: 'locaCd',
        width: this.getColumnWidth('locaTx', 100),
        editable: true,
        cellClass: (params) => {
          return this.inputCellClass(params, 'locaCd');
        },
      },
      {
        headerName: '入荷数',
        field: 'arriveresultNr',
        width: this.getColumnWidth('arriveresultNr', 100),
        editable: true,
        // cellEditor: 'numericCellEditor',
        cellClass: (params) => {
          return this.inputCellClass(params, 'arriveresultNr');
        },
        // valueFormatter: insertcomma,
      }
    ];

    this.height = window.innerHeight - 80;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa1014_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa1014_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa1014_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    this.loginGridHelper.el = this.loginGridView;
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.errorMssageForLogin = '';
      this.isSubmitButtonEnabled = false;

      setTimeout(() => {
        this.onSubmit();
      }, 200);
    } else {
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  onSubmit() {
    this.ownerId = Number(sessionStorage.getItem('wa1014_ownerId'));
    console.log('ownerId:' + this.ownerId);
    this.rowData = JSON.parse(sessionStorage.getItem('selectItemObj'));

    setTimeout(() => {
      this.gridOptions.columnApi.resetColumnState();
      this.gridOptions.columnApi.setColumnVisible('unarr', !this.isFromUnArrival);
    }, 200);
  }

  extractValues(mappings) {
    return Object.keys(mappings).map(k => {
      return mappings[k];
    });
  }

  lookupValue(mappings, key) {
    return mappings[key];
  }

  lookupKey(mappings, name) {
    for (var key in mappings) {
      if (mappings.hasOwnProperty(key)) {
        if (name === mappings[key]) {
          return key;
        }
      }
    }
  }

  cancel() {
    //this.router.navigate(['wa1010']);
    this.closeButtonClick.emit(false);
  }

  showForceOverylay(node) {
    this.forceData = node;
    this.errorMssage2 = '';
    this.isShowForceWin = true;
  }
  closeForceOverlay() {
    this.isShowForceWin = false;
  }
  // 強制終了
  forced() {
    var rowIndex = this.forceData.id;
    this.errorMssageForLogin = '';
    if (this.rowData[rowIndex]['starriveplanId'] == 4) {
      this.working = false;
      this.errorMssageForLogin = '既に入荷完了のため、強制完了は出来ません';
      return;
    } else if (this.rowData[rowIndex]['starriveplanId'] == 0) {
      this.working = false;
      this.errorMssageForLogin = '未入荷が選択されています。未入荷商品の入荷受付は完了出来ません';
      return;
    }

    this.working = true;
    const selectedIndex: number[] = [];
    selectedIndex.push(this.rowData[rowIndex]['arriveplanId']);
    this.arrivePlanService
      .forced(selectedIndex)
      .then(outputJson => {
        this.working = false;
        //this.onSubmit();
        this.rowData.splice(rowIndex, 1);
        this.gridOptions.api.setRowData(this.rowData);
        this.isShowForceWin = false;
        this.closeButtonClick.emit(true);
        sessionStorage.setItem('SuccessInfoMessage', '強制終了が完了しました。');
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorMssageForLogin = this.commonService.getErrorMessage(error);
      });
  }

  saveLoginData() {
    this.errorMssageForLogin = '';
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    let error = 0;
    for (let i = 0; i < this.rowData.length; i++) {
      let rowNum = this.rowData.length - i;
      if (!this.rowData[i].locaCd) {
        this.working = false;
        error = 1;
        this.errorMssageForLogin = rowNum + '行目：格納ロケーションコードは必須です。白枠部分は未確定状態です。入力のうえENTERキーで確定してください。';
        return;
      }
      if (this.rowData[i].locaCd.length > 20) {
        this.working = false;
        error = 1;
        this.errorMssageForLogin = rowNum + '行目：格納ロケーションコードは20文字以内で入力してください';
        return;
      }
      if (!this.rowData[i].arriveresultNr) {
        this.working = false;
        error = 1;
        this.errorMssageForLogin = rowNum + '行目：入荷数は必須です。白枠部分は未確定状態です。入力のうえENTERキーで確定してください。';
        return;
      }
      if (!isNumber(this.rowData[i].arriveresultNr) || this.rowData[i].arriveresultNr > 999999 || this.rowData[i].arriveresultNr <= 0) {
        this.working = false;
        error = 1;
        this.errorMssageForLogin = rowNum + '行目：入荷数は1~999999の間の数字で入力してください';
        return;
      }
    }

    if (error == 0) {
      this.arrivePlanService
        .complete(this.ownerId, this.rowData, 'wa1014')
        .then(outputJson => {
          this.working = false;
          this.closeButtonClick.emit(true);
        })
        .catch(error => {
          this.working = false;
          console.log(this.commonService.getErrorMessage(error));
          this.errorMssageForLogin = this.commonService.getErrorMessage(error);
        });
    }
  }

  ngDoCheck() {
    if (!this.isShow)
      return;

    if (this.rowData == null || this.rowData.length == 0)
      return;
    let error = false;
    var status = [];
    for (let i = 0; i < this.gridOptions.api.getDisplayedRowCount(); i++) {
      let rowNum = this.rowData.length - i;
      var row = this.gridOptions.api.getDisplayedRowAtIndex(i).data;

      if (!row.locaCd) {
        status.push(false);
        continue;
      }
      if (row.locaCd.length > 20) {
        status.push(false);
        continue;
      }
      if (!row.arriveresultNr) {
        status.push(false);
        continue;
      }
      if (!isNumber(row.arriveresultNr) || row.arriveresultNr > 999999 || row.arriveresultNr <= 0) {
        status.push(false);
        continue;
      }

      status.push(true);
    }

    status.forEach(v => {
      if (v == true)
        error = true;
    });

    this.isSubmitButtonEnabled = error;
  }


  inputCellClass(params, field) {

    for (let i = 0; i < params.value; i++) {

      if (params.value[i][this.ARRIVE_RANDOM_PROP_NAME] == null) {

        var cls = null;
        if (params.value[i] != null && (params.value[i] + '') !== '') {

          cls = 'txtactive';
        }
        return this._inputCellClass(params, cls);
      }
    }
    return this._inputCellClass(params, null);
  }
  _inputCellClass(params, cls) {
    var defaultClss = ['tr', 'cellclass', 'editClass', 'noCellFocus'];
    if (cls == null) {
      var rowDOM = this.loginGridView.nativeElement.querySelectorAll('div[role="row"]');

      if (rowDOM != null) {
        rowDOM.forEach(item => {

          if (!item.hasAttribute('row'))
            return;
          var rowValue = item.getAttribute('row');
          if (rowValue !== params.node.id)
            return;

          var cells = item.querySelectorAll('.ag-cell[role="gridcell"][colId="' + params.colDef.field + '"]');//
          if (cells.length == 0)
            return;

          if (cells[0].classList.contains('txtactive'))
            cells[0].classList.remove('txtactive');
        });
      }
      return defaultClss;
    }
    defaultClss.push(cls);
    return defaultClss;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa1Arrival/wa1014/wa1014.component.ts